import dayjs from "dayjs";

function copyToClipboard(textToCopy) {
  // Navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(textToCopy);
  } else {
    // Use the 'out of viewport hidden text area' trick
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;

    // Move textarea out of the viewport so it's not visible
    textArea.style.position = "absolute";
    textArea.style.left = "-999999px";

    document.body.prepend(textArea);
    textArea.select();

    try {
      document.execCommand("copy");
    } catch (error) {
      console.error(error);
    } finally {
      textArea.remove();
    }
  }
}

const MILLISECONDS_IN_TWENTY_MINUTES = 20 * 60 * 1000;
function logSkipVideo(videoId, maxSkips = 3, hasPartyPass = false) {
  // If user has Party Pass, allow unlimited skips
  if (hasPartyPass) {
    return true;
  }

  // Otherwise, enforce skip limit
  const firstSkipAt = Number(localStorage.getItem("firstSkipAt"));
  const skippedVideos = localStorage.getItem("skipVideos");
  const parsedSkippedVideos = JSON.parse(skippedVideos || "[]");

  if (
    !firstSkipAt ||
    dayjs.utc().diff(dayjs(firstSkipAt), "milliseconds") >
      MILLISECONDS_IN_TWENTY_MINUTES
  ) {
    localStorage.setItem("firstSkipAt", new Date().getTime());
    localStorage.setItem("skipVideos", JSON.stringify([videoId]));
    return true;
  } else if (parsedSkippedVideos.length < maxSkips) {
    parsedSkippedVideos.push(videoId);
    localStorage.setItem("skipVideos", JSON.stringify(parsedSkippedVideos));
    return true;
  }
  return false;
}

const EXTENSION_TO_TYPE = {
  '.mp4': 'video/mp4',
  '.webm': 'video/webm',
  '.ogg': 'video/ogg',
  '.m3u8': 'application/x-mpegURL',
  '.mov': 'video/quicktime',
  '.avi': 'video/x-msvideo',
  '.flv': 'video/x-flv',
  '.wmv': 'video/x-ms-wmv',
  '.mkv': 'video/x-matroska',
  '.3gp': 'video/3gpp',
  '.ogv': 'video/ogv',
  '.ts': 'video/mp2t',
  '.mpd': 'application/dash+xml',
  '.vob': 'video/dvd',
  '.iso': 'application/x-iso9660-image',
  '.rm': 'application/vnd.rn-realmedia',
  '.rpm': 'audio/x-pn-realaudio-plugin',
  '.m2ts': 'video/mp2t',
  '.qt': 'video/quicktime'
};

function getVideoMimeType(url) {
  const fileExtension = url.substring(url.lastIndexOf('.')).toLowerCase();
  
  return EXTENSION_TO_TYPE[fileExtension] || null;
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function validateOnlyNumbers(value) {
  return  /^\d*$/.test(value);
}

function trackGoogleAnalyticsEvent(eventName, eventParameters = {}) {
  try {
    // Send event to Google Analytics using gtag
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
    }
  } catch (error) {
    console.error('Error tracking analytics event:', error);
  }
}

export { copyToClipboard, logSkipVideo, getVideoMimeType, isValidEmail, validateOnlyNumbers, trackGoogleAnalyticsEvent };
